export default __webpack_public_path__ + "static/media/react.8cfd247b.svg";